import { connect } from 'react-redux';
import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { toggleModalLogin, logoutUser } from './../../actions/UserActions';

const HomePaymentAward = ({ coverHome, descriptionsHome, urlHome, user, toggleModal }) => {
  const renderizarTexto = () => {
    return { __html: descriptionsHome };
  };

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleConoceMasClick = () => {
    if (!user) {
      toggleModal('1');
    } else {
      setIsLoggedIn(true);
    }
  };

  if (isLoggedIn) {
    return <Redirect to={urlHome} />;
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-12 col-lg-12 py-3 text-center align-center result-position">
          <h2 className="texto-responcive my-0 d-inline-block first-title-consulta text-white">Pago de premios loterías</h2>
        </div>
        <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8 texto-responcive align-middle text-center">
          <h3 className="texto-responcive my-0 d-inline-block first-title-consulta text-white" dangerouslySetInnerHTML={renderizarTexto()}></h3>
        </div>
        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 text-center align-center result-position">
          <img class="img" src={coverHome} width='200px' />
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 py-3 text-center align-middle boton-acomodar">
          <a className="button-rounded button-rounded-gradient-resultados lg py-3 button-shadow" onClick={handleConoceMasClick}>
            Reclama tu premio
          </a>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { loading, error, user } = state.homepayprize.homepayPrize;
  return {
    loading,
    error,
    user: state.authentication.user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleModal(tab) {
      dispatch(toggleModalLogin(tab));
    },
    logoutUser() {
      dispatch(logoutUser());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePaymentAward);
